import { TypographyProps, ButtonProps, Box } from '@mui/material';
import { MenuItem } from 'generated/graphql';
import { ItemLink } from './ItemLink';

type CenteredItemLinkProps = {
    item: MenuItem;
    typographyProps?: TypographyProps;
    buttonProps?: ButtonProps;
    onClick?: () => void;
};

export function CenteredItemLink(props: CenteredItemLinkProps) {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
        }}
        >
            <ItemLink {...props} />
        </Box>
    );
}
